import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './features/authentication/pages/login/login.component';
import { RequestPasswordResetComponent } from './features/authentication/pages/request-password-reset/request-password-reset.component';
import { ResetPasswordComponent } from './features/authentication/pages/reset-password/reset-password.component';
import { ValidateAccountComponent } from './features/authentication/pages/validate-account/validate-account.component';
import { ParametrageComponent } from './features/layout/components/parametrage/parametrage.component';
import { IndexPageComponent } from './features/layout/index-page/index-page.component';
import { GestionEvenementComponent } from './pages/administrateur/gestion-jardin/gestion-evenement/gestion-evenement.component';
import { GestionMessagariesComponent } from './pages/enseignant/gestion-messagaries/gestion-messagaries.component';
import { GestionEnfantsComponent } from './pages/enseignant/gestion-enfants/gestion-enfants.component';
import { GestionEvaluationComponent } from './pages/enseignant/gestion-evaluation/gestion-evaluation.component';
import { ModalsComponent } from './core/components/modals/modals.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { RouterModule } from '@angular/router';
import { InjectableRxStompConfig, RxStompService, rxStompServiceFactory } from '@stomp/ng2-stompjs';
import { myRxStompConfig } from './pages/administrateur/gestion-jardin/gestion-messagarie/myRxStompConfig';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DashboardsAdminComponent } from './pages/administrateur/dashboard/dashboards-admin/dashboards-admin.component';
import { MentionsLegalesComponent } from './features/legal/mentions-legales/mentions-legales.component';
import { ConfidentialiteComponent } from './features/legal/confidentialite/confidentialite.component';
import { NgChartsModule } from 'ng2-charts';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    ModalsComponent,
    LoginComponent,
    RequestPasswordResetComponent,
    ResetPasswordComponent,
    ValidateAccountComponent,
    ParametrageComponent,
    IndexPageComponent,
    GestionEvenementComponent,
    GestionMessagariesComponent,
    GestionEnfantsComponent,
    GestionEvaluationComponent,
    DashboardsAdminComponent,
    MentionsLegalesComponent,
    ConfidentialiteComponent
  ],
  imports: [
    BrowserModule,
    TranslateModule.forRoot({
      defaultLanguage: 'fr',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    FormsModule,
    NzModalModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NzNotificationModule,
    RouterModule.forRoot([]), // Ensure this is configured
    NgChartsModule
  ],
  providers: [
    provideClientHydration(),
    [provideHttpClient(withFetch())],
    {
      provide: RxStompService,
      useFactory: rxStompServiceFactory,
      deps: [InjectableRxStompConfig],
    },
    {
      provide: InjectableRxStompConfig,
      useValue: myRxStompConfig,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]  // Enables support for custom elements
})
export class AppModule { }

